export default "__VITE_ASSET__C2tIudy4__"